import React from 'react';
import './index.less';
import UserRoleSelect from '../../auth/user/roleSelect/userRoleSelect'
import { WizTableForm } from '../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const positionCategoryConfig = WizTableForm.Config.positionCategory()
const roleConfig = WizTableForm.Config.roleInfo(this, {apiParams : {}});
import { component_tool } from '../../../tool'
let { WizModal, WizPopover } = component_tool;

//配置项
let componentName = "personManage";
let ref;
const columns = (searchProps = {}) => {
  let organizationIdListProps = { ...organizationConfig }
  if (searchProps['org'] && searchProps['org'].length) {
    let org = searchProps['org'][0]
    organizationIdListProps = {
      ...organizationConfig,
      initialValue: [org['orgId']],
      initRows: [{ id: org['orgId'], name: org['orgName'] }],
    }
  }
  return [
    {
      name: "personId"
    },
    {
      title: "账号",
      name: "userName",
      dataIndex: "userName",
      searchItem: {},
      tableItem: {},
      formItem: {}
    },
    {
      title: "姓名",
      name: "fullName",
      dataIndex: "fullName",
      searchItem: {
      },
      tableItem: {},
      formItem: {}
    },
    {
      title: "昵称",
      name: "nickName",
      dataIndex: "nickName",
      tableItem: {},
      formItem: {}
    },
    {
      title: "手机号",
      name: "mobile",
      dataIndex: "mobile",
      searchItem: {},
      tableItem: {},
      formItem: {}
    },
    /* {
      title: "证件号码",
      name: "idCard",
      dataIndex: "idCard",
      formItem: {},
      searchItem: {
      },
      tableItem: {}
    }, */
    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      tableItem: {},
      formItem: {},
      dict: [
        { code: 1, codeName: "激活" },
        { code: 0, codeName: "禁用" }
      ],
      searchItem: {
        type: "select"
      }
    },
    {
      title: "用户属性",
      name: "userType",
      dataIndex: "userType",
      formItem: {},
      tableItem: {},
      dict: [
        { code: 0, codeName: "培训平台用户" },
        { code: 5, codeName: "服务商用户" },
        { code: 4, codeName: "经销商用户" },
        { code: 3, codeName: "OEM部门用户" }
        // { code: 5, codeName: "FSE" }
      ],
    },
    {
      title: "用户属性",
      name: "userTypeList",
      dataIndex: "userTypeList",
      dict: [
        { code: 0, codeName: "培训平台用户" },
        { code: 5, codeName: "服务商用户" },
        { code: 4, codeName: "经销商用户" },
        { code: 3, codeName: "OEM部门用户" }
        // { code: 5, codeName: "FSE" }
      ],
      searchItem: {
        type: "select",
        mode: 'multiple',
      }
    },
    // {
    //   title: "实名认证",
    //   name: "introduce",
    //   dataIndex: "introduce",
    //   formItem: {},
    //   tableItem: {}
    // },
    {
      title: "数据来源",
      name: "channel",
      dataIndex: "channel",
      formItem: {},
      tableItem: {},
      dict: [
        { code: 0, codeName: "系统" },
        { code: 4, codeName: "Idaas平台" },
      ],
      searchItem: {
        type: "select"
      }
    },
    {
      title: "任职信息",
      name: "identityInfos",
      formItem: {},
      tableItem: {
        // width: 300,
        render: (val = [], record) => {
          if (!val.length) { return '暂无任职' }
          let { orgName, positionName } = val[0]
          let _titleView = [`${orgName}-${positionName}`]
          if (val.length > 1) {
            _titleView.push(<span className='manager-person-text-color'> ...</span>)
          }

          return (
            <WizPopover
              content={val.map((e) => <p>{`${e['orgName']}-${e['positionName']}`}</p>)}
              placement="rightTop"
            >
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: "入职时间",
      name: "hireTime",
      dataIndex: "hireTime",
      formItem: {},
      tableItem: {}
    },
    {
      title: "组织机构",
      name: "organizationIdList",
      searchItem: {
        diy: WizTableForm,
        ...organizationIdListProps
      }
    },
    {
      title: "岗位",
      name: "positionIdList",
      searchItem: {
        diy: WizTableForm,
        ...positionConfig,
      }
    },
    {
      title: "岗位分类",
      name: "positionCategoryId",
      searchItem: {
        type: "select",
        selectType: 'radio',
        diy: WizTableForm,
        ...positionCategoryConfig,
      }
    },
    {
      title: '站点类型',
      name: 'dealerTypeList',
      dict: [
        {code: 1, codeName: '经销商'},
        {code: 2, codeName: '服务商'},
        { code: 99, codeName: '暂定' },
        { code: 0, codeName: '无' }
      ],
      searchItem: {
        type: 'select'
      },
    },
    {
      title: "角色",
      name: "roleIdList",
      searchItem: {
        type: "select",
        selectType: 'radio',
        diy: WizTableForm,
        ...roleConfig,
      }
    },
    {
      title: "任职来源",
      name: "identityChannel",
      dict: [
        { code: 0, codeName: "系统" },
        { code: 4, codeName: "Idaas平台" },
      ],
      searchItem: {
        type: "select"
      }
    },
  ];
}

const templateConfig = ({ searchProps, btnAccessCheck }) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(searchProps),
        btnAccessCheck: btnAccessCheck,
        searchBarProps: {
          buttonSort: ['add', 'exportPersonInfo','exportRandomNumberPersonInfo', 'exportJobInfo','importTemporaryPerson','importSchoolCooperationPerson','importPerson', 'batchEnable', 'batchDisable'],
          buttons: [
            {
              key: "add",
              custom: true,
              params: { children: "新增", icon: "plus", type: "primary" },
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: "/org/person/personDetailAdd"
                }
              }
            },
            {
              key: 'importTemporaryPerson',
              custom: true,
              params: { icon: 'importTemporaryPerson', children: '导入临时人员', type: 'importTemporaryPerson'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/org/person/import',
                }
              }
            },
            {
              key: 'importSchoolCooperationPerson',
              custom: true,
              params: { icon: 'importSchoolCooperationPerson', children: '导入校企合作人员', type: 'importSchoolCooperationPerson'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/org/person/importSchoolCooperationPerson',
                }
              }
            },
            {
              key: 'importPerson',
              custom: true,
              params: { icon: 'importPerson', children: '导入人员', type: 'importPerson'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/org/person/importPerson',
                }
              }
            },
            // {
            //   key: "resetPass",
            //   custom: true,
            //   needSelect: true,
            //   params: { children: "重置密码" },
            //   customOnClick: {
            //     key: "action",
            //     params: {
            //       apiKey: "reset",
            //       apiParams: {},
            //     },
            //     formatParams: (rows) => {
            //       let ids = []
            //       rows.forEach(row => {
            //         ids.push(row['personId'])
            //       });
            //       return { ids };
            //     }
            //   }
            // },
            {
              key: "exportPersonInfo",
              custom: true,
              params: { icon: 'export', children: '导出人员信息', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "personInfoExport",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: "exportJobInfo",
              custom: true,
              params: { icon: 'export', children: '导出任职信息', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "personIdentityInfoExport",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: "exportRandomNumberPersonInfo",
              custom: true,
              params: { icon: 'export', children: '导出人员(序号随机)', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "personInfoExportRandomNumber",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'batchEnable',
              custom: true,
              params: {children: '批量启用', type: 'danger'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "batchChangeState"
                },
                formatParams: (rows, record, filters, callback) => {
                  let ids = [];
                  rows.forEach(row => {ids.push(row.id)})
                  const content = ids.length ? `${"您确定要启用选中的人员吗?"}` : '至少选择一条数据';
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      ids.length && callback && callback({disabled: 0, personIds: ids,})
                    },
                    onCancel() { }
                  });
                  return null
                }
              }
            },
            {
              key: 'batchDisable',
              custom: true,
              params: {children: '批量禁用', type: 'danger'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "batchChangeState"
                },
                formatParams: (rows, record, filters, callback) => {
                  let ids = [];
                  rows.forEach(row => {ids.push(row.id)})
                  const content = ids.length ? `${"您确定要禁用选中的人员吗?"}` : '至少选择一条数据';
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      ids.length && callback && callback({disabled: 1, personIds: ids,})
                    },
                    onCancel() { }
                  });
                  return null
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "personId",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['look', 'update', 'activationOrDisable', 'adjustManagementScope', 'roleAdjustment', 'verifiedManagement', 'resetPassword', 'changeLog'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: { children: "查看"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/org/person/personInfoDetail"
              }
            }
          },
          {
            key: "update",
            custom: true,
            params: { children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/org/person/personDetailUpd"
              }
            }
          },
          {
            key: "activationOrDisable",
            custom: true,
            params: { children: "启用"},
            textFormat: {
              recordKey: 'state',
              dirt: { 1: '禁用', 0: '激活' }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 1 ? "禁用" : "启用"
                  }该人员账号吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 0 ? 1 : 0,
                      personId: record['personId'],
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "adjustManagementScope",
            custom: true,
            params: { children: "调整管理范围"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/org/person/administrationScope"
              }
            }
          },
          {
            key: "roleAdjustment",
            custom: true,
            params: { children: "角色调整" },
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "用户角色管理",
                  diy: (e) => {
                    return (
                      <UserRoleSelect
                        key={e.record.id}
                        {...e}
                        ref={r => {
                          ref = r && r.getWrappedInstance();
                        }}
                      />
                    )
                  },
                  onOk: () => {
                    ref._doRoleUserAdd()
                  },
                  onCancel: () => {
                    ref._doInitParams()
                  },
                  width: 850
                }
              }
            }
          },
          {
            key: 'verifiedManagement',
            custom: true,
            params: { children: '实名认证管理' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: "/org/person/personFaceAuthDetail"
              }
            }
          },
          {
            key: "resetPassword",
            custom: true,
            params: { children: "重置密码"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "reset",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要重置该人员的密码吗？重置后密码为SaicCyc778899a。`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ids: [record['personId']]
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "changeLog",
            custom: true,
            params: { children: "变更记录" },
            customOnClick: {
              key: "action",
              params: {}
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = true
              return {disabled}
            }
          }
        ]
      }
    }
  }
};

const apis = (organizationIdList = []) => {
  let listInitProps = {}
  if (organizationIdList.length) {
    listInitProps['organizationIdList'] = organizationIdList
  }
  return {
    personInfoExport: {
      path: `${componentName}/personInfoExport`,
      payload: {
        key: `${componentName}@personInfoExport`,
        apiParams: {}
      }
    },
    personInfoExportRandomNumber: {
      path: `${componentName}/personInfoExportRandomNumber`,
      payload: {
        key: `${componentName}@personInfoExportRandomNumber`,
        apiParams: {}
      }
    },
    personIdentityInfoExport: {
      path: `${componentName}/personIdentityInfoExport`,
      payload: {
        key: `${componentName}@personIdentityInfoExport`,
        apiParams: {}
      }
    },

    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { ...listInitProps }
      }
    },
    enable: {
      path: `${componentName}/enable`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {}
      }
    },
    reset: {
      path: `${componentName}/reset`,
      payload: {
        key: `${componentName}@reset`,
        apiParams: {}
      }
    },
    batchChangeState: {
      path: `${componentName}/batchChangeState`,
      payload: {
        key: `${componentName}@batchChangeState`,
        apiParams: {}
      }
    },
  }
};

let reduxTemplateCofig = args => {
  let { organizationIdList } = args;
  return {
    apis: apis(organizationIdList),
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
